import {Components} from '@mui/material';

const typography: Components = {
  MuiTypography: {
    defaultProps: {
      lineHeight: 1.25,
    },
  },
};

export default typography;
